import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";

const translations = {
  en: {
    // Nav
    nav_home: "Home",
    nav_companions: "Companions",
    nav_studio: "Studio Prices",
    nav_services: "Services",
    nav_blog: "Journal",
    nav_reviews: "Reviews",
    nav_contact: "Contact",
    nav_book: "Book Now",

    // Age Gate
    ag_subtitle: "ESCORT AGENCY · ATHENS · VIP MODELS",
    ag_text:
      "You are about to enter an exclusive directory of luxury companions intended strictly for adults of legal age.",
    ag_confirm: "PLEASE CONFIRM YOU ARE 18 OR OLDER",
    ag_enter: "I AM 18 OR OLDER — ENTER",
    ag_exit: "EXIT",
    ag_disclaimer:
      "By entering you agree this site contains adult content and confirm you access it of your own volition.",

    // Hero
    hero_eyebrow: "ATHENS · EST. MMXXVI · BY INVITATION",
    hero_title_1: "The art of",
    hero_title_2: "extraordinary",
    hero_title_3: "company.",
    hero_text:
      "A privately curated circle of the most exceptional women in Greece. Every introduction is handled with discretion, every evening built to be unforgettable.",
    hero_cta_view: "View Companions",
    hero_cta_arrange: "Arrange an Evening",
    hero_badge: "Verified Profiles Only",

    // Values
    val_premium: "Ultra-Premium",
    val_premium_t: "Hand-selected, world-class",
    val_verified: "100% Verified",
    val_verified_t: "Real photos. Real ladies.",
    val_discretion: "Total Discretion",
    val_discretion_t: "Encrypted communication",
    val_concierge: "24/7 Concierge",
    val_concierge_t: "Always at your service",

    // Sections
    inner_circle: "The Inner Circle",
    featured_vip: "Featured",
    featured_vip_italic: "VIP",
    see_all: "See All Companions →",
    different_standard: "A different standard",
    we_curate_1: "We don't list",
    we_curate_everyone: "everyone.",
    we_curate_2: "We curate the",
    we_curate_few: "few.",
    we_curate_text:
      "Every woman who joins Billion Euro Babies is invited personally. We look for presence — the kind of woman who turns a hotel lobby into a moment.",
    stat_verified: "Verified",
    stat_concierge: "Concierge",
    stat_compromise: "Compromise",

    directory: "The Directory",
    meet_angels_1: "Meet our",
    meet_angels_2: "Angels",
    view_full: "View Full Directory →",

    whispered: "Whispered, never written",
    from_clients_1: "From our",
    from_clients_2: "clients",

    cta_tonight_1: "Tonight,",
    cta_tonight_2: "begin.",
    cta_text:
      "One message is all it takes. Our concierge will recommend the perfect companion based on your taste and your evening.",
    cta_arrange: "Arrange Now",
    cta_whatsapp: "WhatsApp Concierge",

    // Companions page
    our_companions_1: "Our",
    our_companions_2: "Companions",
    companions_intro:
      "Browse our curated circle. Every profile is verified and updated personally by our concierge team.",
    filter_service: "Service",
    filter_nationality: "Nationality",
    filter_hair: "Hair",
    filter_age: "Age",
    filter_all_services: "All Services",
    filter_all_countries: "All Countries",
    filter_all_colours: "All Colours",
    filter_min: "Min",
    filter_max: "Max",
    filter_reset: "Reset",
    no_matches: "No matches",
    no_matches_text: "Try adjusting your filters.",
    loading: "Loading...",
    companion_count_one: "companion",
    companion_count_many: "companions",
    view_profile: "View Profile →",
    verified: "Verified",
    per_hour: "per hour",
    hour_short: "/hour",

    // Detail
    back_to_directory: "Back to Directory",
    years: "years",
    height: "Height",
    measurements: "Measurements",
    hair_label: "Hair",
    languages: "Languages",
    services_label: "Services",
    incall: "In-call",
    outcall: "Out-call",
    available: "Available",
    unavailable: "Unavailable",
    book_whatsapp: "Book via WhatsApp",
    book_call: "Call to Reserve",

    // Services
    services_eyebrow: "What we offer",
    services_title_1: "Bespoke",
    services_title_2: "Services",
    services_intro:
      "Every booking is tailored. Below is a guide — but the truth is, we arrange whatever the evening requires.",
    svc_gfe: "Girlfriend Experience",
    svc_gfe_t:
      "An evening that feels effortless and entirely real. Conversation, affection, attention — exactly as you'd expect from someone you've known for years.",
    svc_dinner: "Dinner Dates",
    svc_dinner_t:
      "From Michelin tables in Kolonaki to private rooftops with views of the Acropolis. She'll know which wine to order and exactly when to laugh.",
    svc_travel: "Travel Companion",
    svc_travel_t:
      "Yacht weeks in the Cyclades, ski chalets in Verbier, business in Dubai. She is well-traveled, fluent, and elegantly packed within an hour.",
    svc_couples: "Couples & Duo",
    svc_couples_t:
      "For the curious couple. Discreet, judgment-free arrangements with our most experienced and warm-hearted ladies.",
    svc_business: "Business Events",
    svc_business_t:
      "Galas, board dinners, private viewings. The right companion adds gravitas to a room. Ours add it without ever raising her voice.",
    svc_overnight: "Overnight Stays",
    svc_overnight_t:
      "The deepest indulgence — an entire evening, an entire morning. Booked from sundown to sunrise at the suite of your choice.",
    how_begin: "How to begin",
    three_steps_1: "Three steps to a",
    three_steps_2: "flawless",
    three_steps_3: "evening.",
    step_choose: "Choose",
    step_choose_d: "Browse profiles, or let our concierge recommend.",
    step_confirm: "Confirm",
    step_confirm_d: "Message us with your evening — time, place, taste.",
    step_indulge: "Indulge",
    step_indulge_d: "Open the door. The rest is taken care of.",

    // Reviews
    reviews_intro:
      "We do not solicit reviews. What follows arrived voluntarily — from men who value discretion and who, for once, made an exception.",

    // Contact
    contact_eyebrow: "Reach our concierge",
    contact_title_1: "Arrange your",
    contact_title_2: "evening",
    contact_intro:
      "Our team responds within minutes. Tell us the date, the preference, the suite — we handle the rest.",
    wa_preferred: "WhatsApp · Preferred",
    viber_label: "Viber",
    direct_line: "Direct line · 24/7",
    email_label: "Email",
    send_message: "Send a discreet message",
    your_name: "Your Name",
    email_optional: "Email (optional)",
    phone_wa: "Phone / WhatsApp",
    tell_us: "Tell us about your evening",
    send_request: "Send Request",
    sending: "Sending...",
    discretion: "Total discretion. No data ever shared.",
    success_msg:
      "Your message has been received. Our concierge will contact you shortly.",
    error_msg: "Something went wrong. Please try WhatsApp directly.",

    // Footer
    footer_text:
      "The leading luxury companion directory of Athens — verified profiles, absolute discretion, and a clientele that expects nothing less than excellence. Luxury beyond imagination.",
    f_directory: "Directory",
    f_all: "All Companions",
    f_services: "Services",
    f_reviews: "Reviews",
    f_booking: "Booking",
    f_contact: "Contact",
    f_rights: "18+ Only · All Rights Reserved",
    f_location: "Athens · Greece",
  },
  gr: {
    nav_home: "Αρχική",
    nav_companions: "Συνοδοί",
    nav_studio: "Τιμές Studio",
    nav_services: "Υπηρεσίες",
    nav_blog: "Άρθρα",
    nav_reviews: "Κριτικές",
    nav_contact: "Επικοινωνία",
    nav_book: "Κράτηση",

    ag_subtitle: "ΓΡΑΦΕΙΟ ΣΥΝΟΔΩΝ · ΑΘΗΝΑ · VIP ΜΟΝΤΕΛΑ",
    ag_text:
      "Πρόκειται να εισέλθετε σε έναν αποκλειστικό κατάλογο συνοδών πολυτελείας, αυστηρά για ενήλικες.",
    ag_confirm: "ΕΠΙΒΕΒΑΙΩΣΤΕ ΟΤΙ ΕΙΣΤΕ 18 ΕΤΩΝ Ή ΑΝΩ",
    ag_enter: "ΕΙΜΑΙ 18 Ή ΑΝΩ — ΕΙΣΟΔΟΣ",
    ag_exit: "ΕΞΟΔΟΣ",
    ag_disclaimer:
      "Με την είσοδό σας αποδέχεστε ότι το site περιέχει περιεχόμενο για ενήλικες και ότι το επισκέπτεστε με δική σας θέληση.",

    hero_eyebrow: "ΑΘΗΝΑ · EST. MMXXVI · ΜΕ ΠΡΟΣΚΛΗΣΗ",
    hero_title_1: "Η τέχνη της",
    hero_title_2: "εξαιρετικής",
    hero_title_3: "συντροφιάς.",
    hero_text:
      "Ένας ιδιωτικά επιμελημένος κύκλος των πιο εξαιρετικών γυναικών στην Ελλάδα. Κάθε γνωριμία αντιμετωπίζεται με διακριτικότητα, κάθε βράδυ είναι αξέχαστο.",
    hero_cta_view: "Δείτε τις Συνοδούς",
    hero_cta_arrange: "Κλείστε ραντεβού",
    hero_badge: "Μόνο Επαληθευμένα Προφίλ",

    val_premium: "Ultra-Premium",
    val_premium_t: "Επιλεγμένες, παγκόσμιας κλάσης",
    val_verified: "100% Επαληθευμένα",
    val_verified_t: "Αληθινές φωτογραφίες. Αληθινές γυναίκες.",
    val_discretion: "Απόλυτη Εχεμύθεια",
    val_discretion_t: "Κρυπτογραφημένη επικοινωνία",
    val_concierge: "24/7 Concierge",
    val_concierge_t: "Πάντα στη διάθεσή σας",

    inner_circle: "Ο εσωτερικός κύκλος",
    featured_vip: "Επιλεγμένες",
    featured_vip_italic: "VIP",
    see_all: "Όλες οι Συνοδοί →",
    different_standard: "Διαφορετικά standards",
    we_curate_1: "Δεν παρουσιάζουμε",
    we_curate_everyone: "τις πάντες.",
    we_curate_2: "Επιλέγουμε τις",
    we_curate_few: "λίγες.",
    we_curate_text:
      "Κάθε γυναίκα που εντάσσεται στο Billion Euro Babies προσκαλείται προσωπικά. Ψάχνουμε για παρουσία — τη γυναίκα που μεταμορφώνει ένα lobby ξενοδοχείου σε στιγμή.",
    stat_verified: "Επαληθευμένες",
    stat_concierge: "Concierge",
    stat_compromise: "Συμβιβασμός",

    directory: "Ο Κατάλογος",
    meet_angels_1: "Γνωρίστε τους",
    meet_angels_2: "Αγγέλους μας",
    view_full: "Πλήρης Κατάλογος →",

    whispered: "Ψιθυρισμένες, ποτέ γραμμένες",
    from_clients_1: "Από τους",
    from_clients_2: "πελάτες μας",

    cta_tonight_1: "Απόψε,",
    cta_tonight_2: "ξεκινήστε.",
    cta_text:
      "Ένα μήνυμα αρκεί. Το concierge μας θα προτείνει την ιδανική συνοδό για τη γεύση σας και το βράδυ σας.",
    cta_arrange: "Κλείστε τώρα",
    cta_whatsapp: "WhatsApp Concierge",

    our_companions_1: "Οι",
    our_companions_2: "Συνοδοί μας",
    companions_intro:
      "Περιηγηθείτε στον επιμελημένο κύκλο μας. Κάθε προφίλ είναι επαληθευμένο και ενημερωμένο από την ομάδα concierge.",
    filter_service: "Υπηρεσία",
    filter_nationality: "Εθνικότητα",
    filter_hair: "Μαλλιά",
    filter_age: "Ηλικία",
    filter_all_services: "Όλες οι Υπηρεσίες",
    filter_all_countries: "Όλες οι Χώρες",
    filter_all_colours: "Όλα τα Χρώματα",
    filter_min: "Από",
    filter_max: "Έως",
    filter_reset: "Επαναφορά",
    no_matches: "Καμία αντιστοίχιση",
    no_matches_text: "Προσπαθήστε να ρυθμίσετε τα φίλτρα.",
    loading: "Φόρτωση...",
    companion_count_one: "συνοδός",
    companion_count_many: "συνοδοί",
    view_profile: "Δείτε προφίλ →",
    verified: "Επαληθευμένη",
    per_hour: "ανά ώρα",
    hour_short: "/ώρα",

    back_to_directory: "Πίσω στον Κατάλογο",
    years: "ετών",
    height: "Ύψος",
    measurements: "Διαστάσεις",
    hair_label: "Μαλλιά",
    languages: "Γλώσσες",
    services_label: "Υπηρεσίες",
    incall: "In-call",
    outcall: "Out-call",
    available: "Διαθέσιμο",
    unavailable: "Μη Διαθέσιμο",
    book_whatsapp: "Κράτηση μέσω WhatsApp",
    book_call: "Καλέστε για Κράτηση",

    services_eyebrow: "Τι προσφέρουμε",
    services_title_1: "Εξατομικευμένες",
    services_title_2: "Υπηρεσίες",
    services_intro:
      "Κάθε κράτηση είναι προσωπική. Παρακάτω είναι οδηγός — αλλά στην πραγματικότητα κανονίζουμε ό,τι χρειάζεται το βράδυ.",
    svc_gfe: "Girlfriend Experience",
    svc_gfe_t:
      "Ένα βράδυ που νιώθεις φυσικό και αληθινό. Συζήτηση, στοργή, προσοχή — όπως ακριβώς θα περίμενες από κάποια που γνωρίζεις χρόνια.",
    svc_dinner: "Δείπνα",
    svc_dinner_t:
      "Από τραπέζια Michelin στο Κολωνάκι μέχρι ιδιωτικές ταράτσες με θέα την Ακρόπολη. Θα ξέρει ποιο κρασί να παραγγείλει και πότε να γελάσει.",
    svc_travel: "Ταξιδιωτική Συνοδός",
    svc_travel_t:
      "Εβδομάδες με σκάφος στις Κυκλάδες, σαλέ σκι στο Verbier, business στο Dubai. Καλά ταξιδεμένη, πολύγλωσση, έτοιμη σε μία ώρα.",
    svc_couples: "Ζευγάρια & Duo",
    svc_couples_t:
      "Για το περίεργο ζευγάρι. Διακριτικές διευθετήσεις χωρίς κρίση, με τις πιο έμπειρες κυρίες μας.",
    svc_business: "Επαγγελματικά Events",
    svc_business_t:
      "Γκαλά, board δείπνα, ιδιωτικές προβολές. Η σωστή συνοδός προσθέτει κύρος. Οι δικές μας το προσθέτουν χωρίς να υψώσουν φωνή.",
    svc_overnight: "Διανυκτέρευση",
    svc_overnight_t:
      "Η βαθύτερη απόλαυση — ολόκληρο βράδυ, ολόκληρο πρωί. Κράτηση από ηλιοβασίλεμα έως ανατολή στη σουίτα της επιλογής σας.",
    how_begin: "Πώς να ξεκινήσετε",
    three_steps_1: "Τρία βήματα για ένα",
    three_steps_2: "άψογο",
    three_steps_3: "βράδυ.",
    step_choose: "Επιλέξτε",
    step_choose_d: "Περιηγηθείτε στα προφίλ ή αφήστε το concierge να σας προτείνει.",
    step_confirm: "Επιβεβαιώστε",
    step_confirm_d: "Στείλτε μας μήνυμα — ώρα, τόπος, γούστο.",
    step_indulge: "Απολαύστε",
    step_indulge_d: "Ανοίξτε την πόρτα. Τα υπόλοιπα τα φροντίζουμε εμείς.",

    reviews_intro:
      "Δεν ζητάμε κριτικές. Όσα ακολουθούν ήρθαν εθελοντικά — από άντρες που εκτιμούν τη διακριτικότητα και που, για μία φορά, έκαναν εξαίρεση.",

    contact_eyebrow: "Επικοινωνία με το concierge",
    contact_title_1: "Κλείστε το",
    contact_title_2: "βράδυ σας",
    contact_intro:
      "Η ομάδα μας απαντά σε λεπτά. Πείτε μας την ημερομηνία, την προτίμηση, τη σουίτα — εμείς αναλαμβάνουμε τα υπόλοιπα.",
    wa_preferred: "WhatsApp · Προτιμώμενο",
    viber_label: "Viber",
    direct_line: "Σταθερή γραμμή · 24/7",
    email_label: "Email",
    send_message: "Στείλτε διακριτικό μήνυμα",
    your_name: "Όνομα",
    email_optional: "Email (προαιρετικό)",
    phone_wa: "Τηλέφωνο / WhatsApp",
    tell_us: "Περιγράψτε το βράδυ σας",
    send_request: "Αποστολή",
    sending: "Αποστολή...",
    discretion: "Απόλυτη εχεμύθεια. Κανένα δεδομένο δεν κοινοποιείται.",
    success_msg:
      "Το μήνυμά σας ελήφθη. Το concierge μας θα επικοινωνήσει σύντομα.",
    error_msg: "Κάτι πήγε στραβά. Δοκιμάστε WhatsApp.",

    footer_text:
      "Ο κορυφαίος κατάλογος συνοδών πολυτελείας της Αθήνας — επαληθευμένα προφίλ, απόλυτη διακριτικότητα, πελατεία που δεν δέχεται τίποτα λιγότερο από αριστεία. Luxury beyond imagination.",
    f_directory: "Κατάλογος",
    f_all: "Όλες οι Συνοδοί",
    f_services: "Υπηρεσίες",
    f_reviews: "Κριτικές",
    f_booking: "Κράτηση",
    f_contact: "Επικοινωνία",
    f_rights: "18+ Μόνο · Όλα τα δικαιώματα διατηρούνται",
    f_location: "Αθήνα · Ελλάδα",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("beb_lang") || "en");

  useEffect(() => {
    localStorage.setItem("beb_lang", lang);
    document.documentElement.lang = lang === "gr" ? "el" : "en";
  }, [lang]);

  const t = useCallback(
    (key) => translations[lang]?.[key] ?? translations.en[key] ?? key,
    [lang]
  );
  const toggle = useCallback(() => setLang((l) => (l === "en" ? "gr" : "en")), []);

  const value = useMemo(
    () => ({ lang, setLang, toggle, t }),
    [lang, toggle, t]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
